import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=0e5e4456&scoped=true&"
var script = {}
import style0 from "./Start.vue?vue&type=style&index=0&id=0e5e4456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5e4456",
  null
  
)

export default component.exports